import { userEventModule } from "user/event"
import { resetTabBoxesState } from "../form/tools/tab-boxes"
import { setMenusForUser } from "./tools/menu"
import { applyUiFeaturePreferences } from "./tools/preference"

export const startUIListeners = (): void => {
  userEventModule.on.login("ui-login", ({ userInfo }) => {
    resetTabBoxesState()
    applyUiFeaturePreferences(userInfo)
    setMenusForUser(userInfo)
  })
}
